import React, { useState, useEffect } from "react";
import Axios from "axios";
import { API_BASE_URL, GET_STORE, INSERT_POS_TERMINALS } from "../../Config";
import Swal from "sweetalert2";
import SpinLoader from "../loader/SpinLoader";
const AddPosTerminal = () => {
  const [userDataSession, setUserDataSession] = useState({});
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [storeLoading, setStoreLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [formData, setFormData] = useState({
    Name: "",
    Description: "",
    StoreId: "",
    TerminalType: "System",
    LicenseKey: "",
  });

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    }
  }, []);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setStoreLoading(true);
      Axios.get(`${API_BASE_URL}${GET_STORE}?OrgId=${userDataSession.OrgId}`)
        .then((response) => {
          if (response.data.Status && response.data.ResultData) {
            setStores(response.data.ResultData);
          } else {
            setStores([]);
            setError("Failed to load stores.");
          }
          setStoreLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching stores:", err);
          setStores([]);
          setError("Error loading stores.");
          setStoreLoading(false);
        });
    }
  }, [userDataSession]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear messages on change
    setError("");
    setSuccess("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.Name.trim()) {
      setError("Terminal Name is required.");
      return;
    }
    if (!formData.StoreId) {
      setError("Please select a store.");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");

    const payload = {
      OrgId: userDataSession.OrgId,
      Name: formData.Name.trim(),
      Description: formData.Description.trim(),
      TerminalType: formData.TerminalType,
      StoreId: parseInt(formData.StoreId),
      LicenseKey: formData.LicenseKey.trim(),
      CreatedBy: userDataSession.UserId,
      // IsActive: 1 and CreatedOn handled by DB
    };

    Axios.post(`${API_BASE_URL}${INSERT_POS_TERMINALS}`, payload)
      .then((response) => {
        if (response.data.Status) {
          setSuccess("POS Terminal added successfully!");
          Swal.fire({
            icon: "success",
            title: "Success",
            text: success,
         
            showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
          // Reset form
          setFormData({
            Name: "",
            Description: "",
            StoreId: "",
            TerminalType: "System",
            LicenseKey: "",
          });

    
        } else {
          setError(response.data.Message || "Failed to add terminal.");
          Swal.fire({
            icon: "error",
            title: "Error",
            text: error,
            showConfirmButton: true,
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error adding terminal:", err);
        setError("Something went wrong. Please try again.");
        setLoading(false);
      });
  };

  return (
    <>{loading&&<SpinLoader/>}
      {" "}
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasTerminalAdd {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasTerminalAdd {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasTerminalAdd {
            width: 35% !important;
          }
        }
          
        @media (min-width: 1441px)  {
          #offcanvasTerminalAdd {
            width: 20% !important;
          }
        }
        `}
      </style>
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasTerminalAdd"
        aria-labelledby="offcanvasTerminalAddLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasTerminalAddLabel">
            Add New POS Terminal
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body">
          {/* {success && <div className="alert alert-success mb-3">{success}</div>}
        {error && <div className="alert alert-danger mb-3">{error}</div>} */}

          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-6 mb-2">
                <label className="form-label">
                  Terminal Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="Name"
                  value={formData.Name}
                  onChange={handleInputChange}
                  placeholder="Enter terminal name"
                  required
                />
              </div>

              <div className="col-6 mb-2">
                <label className="form-label">
                  Store <span className="text-danger">*</span>
                </label>
                {storeLoading ? (
                  <p>Loading stores...</p>
                ) : (
                  <select
                    className="form-select"
                    name="StoreId"
                    value={formData.StoreId}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">-- Select Store --</option>
                    {stores.map((store) => (
                      <option key={store.Id} value={store.Id}>
                        {store.Name}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              <div className="col-6 mb-2">
                <label className="form-label">Terminal Type</label>
                <select
                  className="form-select"
                  name="TerminalType"
                  value={formData.TerminalType}
                  onChange={handleInputChange}
                >
                  <option value="System">System</option>
                  <option value="Tab">Tab</option>
                </select>
              </div>

              <div className="col-6 mb-2">
                <label className="form-label">License Key</label>
                <input
                  type="text"
                  className="form-control"
                  name="LicenseKey"
                  value={formData.LicenseKey}
                  onChange={handleInputChange}
                  placeholder="Enter license key "
                />
              </div>
              <div className="col-12">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  name="Description"
                  rows="3"
                  value={formData.Description}
                  onChange={handleInputChange}
                  placeholder="Enter description "
                ></textarea>
              </div>
            </div>
            <div className=" d-flex justify-content-end p-3">
              <button
                type="submit"
                className="btn btn-primary me-2"
                disabled={loading}
              >
                {loading ? "Adding..." : "Save"}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="offcanvas"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddPosTerminal;
